
export class GetTagListRequestModel {
  // Pコード
  public pCode: string = <string>'';
}
